import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import CModal from '../CModal/Index';
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { Button, Input, FormControl, FormErrorMessage, FormLabel, HStack, Select, useToast, Stack } from '@chakra-ui/react';
import Api from '../../Api/Api';
const chrema = yup.object({
    nome: yup.string().required("Insere o nome da escola."),
    ies: yup.string().notRequired()
}).required("Campo obrigatório.");

function ModalCriarEscola({
    open,
    onClose
}) {
    const [load, setLoad] = useState(false);
    const [ies, setIes] = useState([]);
    const {
        register,
        formState: { errors },
        handleSubmit
    } = useForm({
        resolver: yupResolver(chrema)
    })
    const toast = useToast();
    function registrarEscola(data) {
        setLoad(true);
        Api.post("Escola/Criar", data)
            .then(() => {
                toast({
                    title: "Escola registrada com sucesso!",
                    duration: 5000,
                    isClosable: true,
                    status: "success"
                })
                setLoad(false)
                onClose()
            })
            .catch(err => {
                setLoad(false)
                console.log({ "Escola/Criar": err.response.data });
            })
    }

    useEffect(() => {
        Api.get("unidade/ListAll")
            .then(res => {
                setIes(res.data)
            })
    }, [])

    return (
        <CModal
            open={open}
            onClose={onClose}
            title="Registrar nova escola"
        >
            <form onSubmit={handleSubmit(registrarEscola)}>
                <Stack spacing={4}>
                    <FormControl isInvalid={errors.nome !== undefined}>
                        <FormLabel>Nome da escola</FormLabel>
                        <Input {...register("nome")} name="nome" />
                        <FormErrorMessage>{errors.nome?.message}</FormErrorMessage>
                    </FormControl>
                    <FormControl isInvalid={errors.ies !== undefined}>
                        <FormLabel>IES da escola</FormLabel>
                        <Select {...register("ies")}>
                            {
                                ies?.map((e, index) => (
                                    <option key={index} value={e.nome}>{e.nome}</option>
                                ))
                            }
                            <option value="">(nenhum)</option>
                        </Select>
                        <FormErrorMessage>{errors.ies?.message}</FormErrorMessage>
                    </FormControl>

                    <HStack spacing={4} mb="4">
                        <Button variant='gray-outline' onClick={onClose}>
                            Cancelar
                        </Button>
                        <Button isLoading={load} type="submit" variant="dark">
                            Registrar escola
                        </Button>
                    </HStack>
                </Stack>
            </form>
        </CModal>
    );
}

export default ModalCriarEscola;